import { Pet } from 'src/app/auth/_models/pet';
import { ActivatedRoute } from '@angular/router';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { Appointment } from './../../auth/_models/appointment';
import { AppointmentService } from './../../auth/_services/appointment.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pet-detail-consulting',
  templateUrl: './pet-detail-consulting.component.html',
  styleUrls: ['./pet-detail-consulting.component.css'],
  providers: [AppointmentService]
})
export class PetDetailConsultingComponent implements OnInit {

  appointmentsPending: Appointment[];
  appointmentsCancelled: Appointment[];
  appointmentsFinished: Appointment[];
  pet: Pet;

  constructor(
    private _appointmentsService: AppointmentService,
    private _petsService: PetsService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {

    this._route.parent.params.subscribe(params => {
      const uuid = params['id'];
      this._petsService.getPetById(uuid)
        .subscribe(pet => {
          this.pet = pet;
          this._appointmentsService.getAppointments(this.pet, 0)
            .subscribe(appointmentsPending => {
              this.appointmentsPending = appointmentsPending;
            });
          this._appointmentsService.getAppointments(this.pet, 1)
            .subscribe(appointmentsCancelled => {
              this.appointmentsCancelled = appointmentsCancelled;
            });
          this._appointmentsService.getAppointments(this.pet, 2)
            .subscribe(appointmentsFinished => {
              this.appointmentsFinished = appointmentsFinished;
            });
        });
    });

  }

}
